import { useEffect, useState } from "react";
import { Server } from "lucide-react";
import { api } from "@/lib/api";

export function SystemModeCard() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/system/mode").then(({ data }) => setM(data)).catch(() => {}); }, []);
  if (!m) return null;
  const prod = m.mode === "production";
  return (
    <div className={`panel p-4 ${prod ? "border-emerald-300" : "border-amber-300"}`} data-testid="system-mode-card">
      <div className="flex items-center gap-2 text-[13px] font-semibold"><Server className="h-4 w-4" />Çalışma modu:
        <span className={`px-2 py-0.5 rounded text-[11px] uppercase ${prod ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}`} data-testid="system-mode-value">{m.mode}</span></div>
      <div className="text-[12px] text-slate-600 mt-1">{m.reason} · MongoDB: {m.mongo} · İşlem modu: {m.transactions}</div>
      {!prod && <div className="text-[11px] text-amber-700 mt-1">Preview: demo hesap kısayolları görünür. Production'da demo hesapları kapatılır ve şifre değişikliği zorunlu olur.</div>}
    </div>
  );
}
